/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Forbidden_DescInputs */

const vi_warehouse_sales_forbidden_desc = /** @type {(inputs: Warehouse_Sales_Forbidden_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ quản trị viên để cấp quyền warehouse_sales.read.`)
};

/**

* @param {Warehouse_Sales_Forbidden_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_forbidden_desc = /** @type {((inputs?: Warehouse_Sales_Forbidden_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Forbidden_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_forbidden_desc(inputs)
});